import React from 'react';
import { ListFieldSection, PageSection } from '../../../Layout';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../Core/types';
import { WorksheetAssociatedTestSection } from '../../Core';
import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { useSelector } from 'react-redux';
import externalTestMethods from '../../ExternalTestMethods';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isLabMoistureContentTaken =
    (useSelector(createWorksheetSelector!('IsLabMoistureContentTaken')) as boolean | undefined) ?? false;
  const importedMoistureContentId = useSelector(
    createWorksheetSelector!('AssociatedMoistureContentTest.ImportedTest.Id')
  );
  return (
    <PageSection heading="Laboratory Moisture Content">
      <Field
        input={<RadioGroup />}
        label="Laboratory Moisture Content Taken"
        name="IsLabMoistureContentTaken"
        confirmText="All data entered for the laboratory moisture content will be lost. Delete the laboratory moisture content?"
        confirm={isLabMoistureContentTaken}
        additionalMessagePaths={['IsLabMoistureContentTaken']}
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />
      {isLabMoistureContentTaken && (
        <WorksheetAssociatedTestSection
          name="AssociatedMoistureContentTest"
          testType="Moisture Content"
          heading="BS 1377-2:1990 Clause 3.2 Moisture"
          associatedTestModel={{
            measured: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field input={<TextOutput />} label="Moisture Content (%)" name="MoistureContent" emph />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedMoistureContentId,
              },
            },
            external: {
              testMethods: [externalTestMethods.moistureContent.BS_1377_2_1990_Clause3_2],
              permitOtherTestMethods: true,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    label="Moisture Content (%)"
                    name="AssociatedMoistureContentTest.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </PageSection>
  );
};

const LabMoistureContent = withInjectedProps(Section);

export { LabMoistureContent };
export default LabMoistureContent;
